import { render, staticRenderFns } from "./NflRankings.vue?vue&type=template&id=1274f067&scoped=true"
import script from "./NflRankings.vue?vue&type=script&lang=js"
export * from "./NflRankings.vue?vue&type=script&lang=js"
import style0 from "./NflRankings.vue?vue&type=style&index=0&id=1274f067&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274f067",
  null
  
)

export default component.exports